import { api } from '@/lib/api';

/**
 * Faz upload de um arquivo (imagem/vídeo) e retorna a URL pública S3.
 * Endpoint genérico `POST /api/uploads?folder=X` (multipart). Limite 16MB no backend.
 */
export async function uploadFile(file: File, folder = 'channel-media'): Promise<string> {
  const formData = new FormData();
  formData.append('file', file);
  const res = await api.post<{ success: boolean; data: { url: string } }>(`uploads?folder=${folder}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data.data.url;
}
